import React from "react";
import Parser from "rss-parser";
import styled from "styled-components";
import { useRssProviderData } from "../../hooks/useRssProviderData";
import ProviderHeader from "../provider-components/ProviderHeader";
import {
  ProviderArticleImg,
  ProviderContent,
  ProviderLink,
  ProviderSection,
} from "../provider-components/ProviderStyles";

const Article = styled.article`
  padding: ${({ theme }) => theme.space[4]};
  border: 3px solid transparent;
  background-color: transparent;
  cursor: pointer;

  &:hover {
    border: 3px solid ${({ theme }) => theme.colors.blueDarker1};
    border-radius: ${({ theme }) => theme.radii[0]};
    background-color: ${({ theme }) => theme.colors.backgroundwhite50};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    padding: ${({ theme }) => theme.space[2]};
    width: 33%;
  }
`;

interface IProps {
  link: string;
  url: string;
  title: string;
  numberOfArticles: number;
}

const ScoutProvider: React.FC<IProps> = ({
  link,
  url,
  title,
  numberOfArticles,
}) => {
  const { providerData } = useRssProviderData({
    url,
    numberOfArticles,
  });

  if (!providerData) {
    return null;
  }

  return (
    <ProviderSection>
      <ProviderHeader title={title} link={link} />
      <ProviderContent backgroundColor="transparent">
        {providerData.map((item: Parser.Item) => {
          return (
            <Article key={item.title}>
              <ProviderLink
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                {item.enclosure && (
                  <ProviderArticleImg
                    src={item.enclosure.url}
                    alt="Article fea"
                  />
                )}
                <h4>{item.title}</h4>
              </ProviderLink>
            </Article>
          );
        })}
      </ProviderContent>
    </ProviderSection>
  );
};

export default ScoutProvider;
